import { FlashyCreateOrUpdate } from "../models/flashy-create-or-update";
import { ClubMember } from "../models/club-member";
import { Club } from "../models/club";

export const buildFlashyContact = (club: Club | null, member: ClubMember, lang: string): FlashyCreateOrUpdate => {
    const data: any = {
        email: member.email,
        first_name: member.firstName,
        last_name: member.lastName,
        phone: member.phone,
        birthday: member.birthdate ?? undefined,
        anniversary: member?.anniversary ?? undefined,
        signup_branch: window.location.hostname,
        loyalty_membership: 1,
        loyalty_membership_created: new Date().toISOString(),
        loyalty_tier: member.clubCode,
        language: lang,
        spouse_birthday: member?.SpouseDateOfBirth ?? undefined,
        spouse_first_name: member?.firstNameSpouse ?? undefined,
        spouse_last_name: member?.lastNameSpouse ?? undefined,
        lists:
            member.agretoMails
                ? { [club?.newsletterClubGroupId || club?.newsletterGeneralGroupId || ""]: true }
                : undefined
    };
    // remove undefined values
    Object.keys(data).forEach(key => {
        if (data[key] === undefined) {
            delete data[key];
        }
    });
    return data;
};